import { render, staticRenderFns } from "./TheProfileFieldsetGeneral.vue?vue&type=template&id=5d067e24&"
import script from "./TheProfileFieldsetGeneral.vue?vue&type=script&lang=js&"
export * from "./TheProfileFieldsetGeneral.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileFieldsetGeneral.vue?vue&type=style&index=0&id=5d067e24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports